import type { Standardprofil } from "./types.js";

/** EFH Sanierung Standard — beachtet Bestandstoleranzen, kleinere Wandstaerken. */
const profil: Standardprofil = {
  id: "efh-sanierung-standard",
  name: "EFH Sanierung Standard",
  projektart: "Sanierung",
  qualitaetsstandard: ["Basis", "Standard"],
  gewerke: {
    rohbau: {
      description:
        "Bestand-Mauerwerk (Annahme: Vollziegel oder KS d=24cm). " +
        "Aufdoppelung WDVS 12-14cm.",
      kriterien: {
        bestand_mauerwerk: "Vollziegel oder Kalksandstein",
        bestand_wandstaerke_mm: 240,
        wdvs_daemmstoffdicke_mm: 140,
      },
      hinweise: [
        "Bestand muss vor Ort gepruefen werden — Profil-Werte sind nur Annahme.",
      ],
    },
    putz: {
      description: "Innen Sanierputz oder Gipsputz. Aussen Mineralputz auf WDVS.",
      kriterien: {
        innen_typ: "Sanierputz oder Gipsputz",
        innen_schichtdicke_mm: 12,
        aussen_typ: "Mineralputz",
        aussen_schichtdicke_mm: 6,
      },
      hinweise: [
        "Bei Feuchteschaeden Sanierputz nach WTA-Merkblatt 2-9 verwenden.",
      ],
    },
    maler: {
      description: "Standard-Beschichtung, ggf. Vorbeschichtung gegen Altanstrich.",
      kriterien: {
        beschichtung: "Dispersionsfarbe",
        anstriche: 2,
        vorbeschichtung: "ggf. Pflicht bei stark saugendem oder schwierigem Untergrund",
      },
    },
    fliesen: {
      description: "Bad/HWR neu fliesen mit Verbundabdichtung.",
      kriterien: {
        boden_rutschhemmung: "R10",
        verbund_abdichtung: "Pflicht",
        dichtband: "Pflicht",
      },
    },
    boden: {
      description: "Laminat oder PVC-Designboden auf vorhandenem Estrich.",
      kriterien: {
        typ: "Laminat AC4 oder Vinyl-Designboden",
        unterlage: "Trittschallunterlage Pflicht",
      },
    },
    estrich: {
      description: "Bestand-Estrich pruefen, ggf. Spachtelmasse.",
      kriterien: {
        bestand_pruefen: "Pflicht",
        spachtelmasse: "ggf. erforderlich",
      },
      hinweise: [
        "Bestand-Estrich auf Risse, Hohllagen, Ebenheit pruefen.",
      ],
    },
    trockenbau: {
      description: "Innenwaende Metallstaender + 2x GKB 12.5mm wenn neu.",
      kriterien: {
        staendertyp: "CW 75",
        beplankung: "2x GKB 12.5mm",
        daemmung_mm: 60,
      },
    },
    decke: {
      description: "Abhaengung mit Metallunterkonstruktion + 1x Gipskarton.",
      kriterien: {
        unterkonstruktion: "Metall CD 60",
        beplankung: "1x GKB 12.5mm",
      },
    },
    tueren: {
      description: "Innentueren CPL beschichtet, Bestand-Masse beachten.",
      kriterien: {
        material: "CPL beschichtet",
        masse: "nach Aufmass Bestand-Zarge",
        anschlagrichtung: "nach Bestand",
      },
      hinweise: [
        "Tuer-Masse muessen pro Tuer aufgemessen werden — Standard-Masse passen selten.",
      ],
    },
    fenster: {
      description: "Kunststofffenster mit 3-fach Verglasung Ug=0.7.",
      kriterien: {
        rahmenmaterial: "Kunststoff",
        verglasung: "3-fach",
        ug_w_m2k: 0.7,
      },
      hinweise: [
        "Fensteranschluss luftdicht ausfuehren (DIN 4108-7).",
      ],
    },
  },
};

export default profil;
